/* @flow */
import * as React from 'react';

import CurrentUser from 'auth/CurrentUser';
import TitleHeader from 'components/TitleHeader';
import Group from 'entities/Group';
import UsersSmsInviteInstructionsPhone from 'users/components/UsersSmsInviteInstructionsPhone';

type Props = {
  group: Group,
};

export default function UsersSmsInviteInstructions({ group }: Props) {
  const alternateNumber = group.getSMSAlternateNumber();
  const code = group.getCode();
  let number;

  if (CurrentUser.isSignedIn()) {
    number =
      !group.useShortCodeForUser(CurrentUser.getUser()) && alternateNumber
        ? alternateNumber
        : group.getSMSNumber();
  } else {
    number =
      !(group.getSubscriptionInfo().sms && group.hasShortCode()) && alternateNumber
        ? alternateNumber
        : group.getSMSNumber();
  }

  if (!code || !number) {
    return null;
  }

  return (
    <div className="UsersSmsInviteInstructions">
      <TitleHeader
        title={`Tell people to text @${code} to the number ${number}`}
        subtext={
          <React.Fragment>
            They’ll receive a welcome text from Remind.
            {alternateNumber && alternateNumber !== number && (
              <React.Fragment>
                <br />
                If anyone has trouble with {number}, they can try texting @{code} to{' '}
                {alternateNumber}.
              </React.Fragment>
            )}
          </React.Fragment>
        }
      />
      <UsersSmsInviteInstructionsPhone code={code} number={number} />
    </div>
  );
}
